import Files from "../assets/js/File";

const state = {
    LoadingFile: false,
    tmpFile: new Files(),
}

const getters = {
    tmpFile: (state) => state.tmpFile,
    LoadingFile: (state) => state.LoadingFile
}

const mutations = {
    SET_TMP_FILE: (state, value) => {
        state.tmpFile = value
    },
    SET_LOADING_FILE: (state, value) => {
        state.LoadingFile = value
    }
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions,
    modules: {},
    namespaced: true,
    strict: true
}
